<template>
    <div class="nav">
      <router-link to="/">
        <img src="../assets/mlogo/mlogo.png"
            srcset="../assets/mlogo/mlogo@2x.png 2x,
                    ../assets/mlogo/mlogo@3x.png 3x"
            class="mlogo">  
      </router-link>
      <img src="../assets/sidenav_ham/ham.png"
        srcset="../assets/sidenav_ham/ham@2x.png 2x,
                ../assets/sidenav_ham/ham@3x.png 3x"
        id="icon_ham" @click="open()"> 

          <div :id="'mySidenav'+this.closemotion" ref="mySidenav" class="sidenav" v-show="this.isOpen > 0 ">
              <!-- v-show="isOpen" -->
            <!-- <div href="javascript:void(0)" class="closebtn" @click="close(isOpen)"><span id="closemark">&times;</span></div> -->
              <a @click="close()"><router-link class="link1st" style="margin-top:7%" to="/">首頁</router-link></a>
              <a @click="close()"><router-link class="link1st" to="/AboutUS">關於金石</router-link></a>
              <!-- <a @click="close()"><router-link class="link2nd" to="/">服務項目</router-link></a> -->
              <a @click="close()"><router-link class="link1st" to="/mobileNews">最新消息</router-link></a>
              <a @click="close()"><router-link class="link1st" to="/mobileAdvocate">金石建案</router-link></a>
              <!-- <a @click="close()"><router-link class="link2nd" to="/advocate/mobilegoldenFront">金石站前湛</router-link></a> -->
              <a @click="close()"><router-link class="link2nd" to="/advocate/mobilegoldenBig">金石成大砌</router-link></a>
              <a @click="close()"><router-link class="link2nd" to="/advocate/mobilegoldenBerkley">金石鉑克萊(完銷)</router-link></a>
              <a @click="close()"><router-link class="link2nd" to="/advocate/mobilegoldenWorld">金石世築(完銷)</router-link></a>
              <a @click="close()"><router-link class="link2nd" to="/advocate/mobilegoldenDragon">金石龍悅</router-link></a>
              <a @click="close()"><router-link class="link2nd" to="/advocate/mobilegoldenIntegrity">金石喆學(完銷)</router-link></a>
              <a @click="close()"><router-link class="link2nd" to="/advocate/mobilegoldenDouble">金石雙響(完銷)</router-link></a>
              <a @click="close()"><router-link class="link2nd" to="/advocate/mobilegoldenPrime">金石首品I(完銷)</router-link></a>
              <a @click="close()"><router-link class="link2nd" to="/advocate/mobilegoldenPrime2">金石首品II(完銷)</router-link></a>
              <a @click="close()"><router-link class="link2nd" to="/advocate/mobilenewPlus">金石＋PLUS(完銷)</router-link></a>
              <a @click="close()"><router-link class="link2nd" to="/advocate/mobilegoldenLV">金石 LV(完銷)</router-link></a>
              <a @click="close()"><router-link class="link1st" to="/mobileContact">聯絡我們</router-link></a>              
              <div :id="'community'+this.closemotion">
                <a href="https://www.facebook.com/kingstonecy1986/">
                   <img src="../assets/sidenav_fb/fb.png"
                     srcset="../assets/sidenav_fb/fb@2x.png 2x,
                             ../assets/sidenav_fb/fb@3x.png 3x"
                      class="icon" id="icon_fb" @click="close()"></a>
                <a href="mailto:cs@kingstonecy.com.tw">      
                   <img src="../assets/sidenav_mail/mail.png"
                     srcset="../assets/sidenav_mail/mail@2x.png 2x,
                             ../assets/sidenav_mail/mail@3x.png 3x"
                      class="icon" id="icon_mail" @click="close()"></a>
                      <!-- </a> -->
              </div>
                <div :class="'whitespace'+this.closemotion">
                    <div href="javascript:void(0)" class="closebtn">
                    <img src="../assets/sidenav_x/x.png"
                        srcset="../assets/sidenav_x/x@2x.png 2x,
                                ../assets/sidenav_x/x@3x.png 3x"
                        :id="'closemark'+this.closemotion" @click="close()">
                    </div>
                </div>
          </div>
        <!-- <img src="../assets/image/mobile_home_bg.png" id="homebackground"> -->
      <!-- </div>  -->

    </div>
</template>
<script>
export default {
    name:'mobilenav',
    data () {
        return{
            isOpen:0,
            closemotion:'',
            windowTop: 0,
        }
    },
  mounted() {
  window.addEventListener("scroll", this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll)
  },
  methods: {
  onScroll(e) {
    this.windowTop = window.top.scrollY /* or: e.target.documentElement.scrollTop */
    // console.log(this.windowTop) 
  },
  openNav() {
    //console.log(this.$refs.mySidenav);
    //   document.getElementById("mySidenav").style.width = "250px";
  },
  open() {
    //   this.isOpen = true;
      this.closemotion = '',
      this.isOpen += 1
    },    
  close() {
    //   this.isOpen = false;
      this.closemotion = 'closemotion'
      //console.log(this.closemotion)
    },
  closeNav() {
    this.$refs.mySidenav.style.width = "0px";
    // document.getElementById("mySidenav").style.width = "0";
  } 
  }
}
</script>

<style scoped>
.nav{
    width: 100%;
    height: auto;
    z-index: 50;
    top: 0;
    position: fixed;
    background: white;
    padding: 2% 0;
}

.mlogo{
  margin: 2% 5% ;
  float: left;
  width: auto;
  height: 29px;
  object-fit: contain;
}
#homemenu{ 
    margin: 0;
    padding: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    position: relative;
    display: block;
  }
#homebackground{
    width: 100%;
    height: 100vh;
 }
 #home_page{
  width: 100vw;
  height: auto;
  display: block;
}
#icon_ham {
    width: 24px;
    height: 19px;
    position: absolute;
    right: 5%;
    margin: auto 0;
    display: inline-block; 
    vertical-align: -webkit-baseline-middle;
    padding-top: 3%;
}

@keyframes sidemotion {
    0%  {      
        opacity: 0.4;
        width: 20%;   }
    100%{  
        opacity: 1;
        width: 100%; 
    }
}
.sidenav {
    top:0;
    opacity:0;
    width: 20%;
    height: 100vh;
    text-align: center;
    position: absolute;
    z-index: 100;
    background-color: rgb(229, 218, 193);
    padding: 0;
    animation: sidemotion 0.8s ease-in-out forwards;
    -webkit-animation: sidemotion 0.8s ease-in-out forwards;
    animation-delay: 0.2s;
    -webkit-animation-delay: 0.2s;
    overflow:scroll
}
@keyframes sidemotion_item{
    0%{ opacity:0; 
        transform: translateY(-4px)}
    100%{ opacity:1; 
        transform: translateY(0px)}
}
#mySidenav a{
    width: 80%;
    height: 22px;
    margin: auto auto auto 20%;
    text-decoration: none;
    display: block;
    transition: 0.3s;
    text-align: left;
    animation: sidemotion_item 0.6s ease-in-out forwards;
    -webkit-animation: sidemotion_item 0.6s ease-in-out forwards;
    animation-delay: 0.8s;
    -webkit-animation-delay: 0.8s;
}

#mySidenav a > .link1st{
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1.93px;
    color: #7c7a7a;
    margin: 30px 0;
    opacity:0;
    animation: sidemotion_item 0.6s ease-in-out forwards;
    -webkit-animation: sidemotion_item 0.6s ease-in-out forwards;
    animation-delay: 0.8s;
    -webkit-animation-delay: 0.8s;
}

#mySidenav a > .link2nd {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1.93px;
    color: #ae9972;
    margin: 20px 0;
    opacity:0;
    animation: sidemotion_item 0.8s ease-in-out forwards;
    -webkit-animation: sidemotion_item 0.8s ease-in-out forwards;
    animation-delay: 1s;
    -webkit-animation-delay: 1s;
}

#mySidenav a.router-link-exact-active {
  	color: #806a4a;
    /* text-decoration: underline; */
    font-weight: 500;
}

.sidenav .closebtn, .whitespace {
  display: inline-block;
}

@keyframes sidemotion_white {
    0%  {      
        opacity: 0.4;
        width: 30px;
  }
    100%{  
        opacity: 1;
        width: 70px;
    }
}
.whitespace{     
    position: absolute;
    top: 0;
    right: 0;
    background: rgb(255, 255, 255);
    opacity:0;
    height: 100vh;
    width: 70px;
    animation: sidemotion_white 0.6s ease-in-out forwards;
    -webkit-animation: sidemotion_white 0.6s ease-in-out forwards;
    animation-delay: 0.4s;
    -webkit-animation-delay: 0.4s;
}
#closemark{
    width: 20px;
    color: #d0ad76;
    margin-top: 27px;
    opacity:0;
    animation: sidemotion_item 0.6s ease-in-out forwards;
    -webkit-animation: sidemotion_item 0.6s ease-in-out forwards;
    animation-delay: 1s;
    -webkit-animation-delay: 1s;
}
@keyframes closemotion{
    0%{  
        opacity: 1;
        width: 100%; 
    }
    100%  {      
        display:none;
        opacity: 0;
        width: 0%;   }
}
#mySidenavclosemotion, #communityclosemotion, .whitespaceclosemotion{ 
    opacity:0;
    animation: closemotion 0.6s ease-in-out forwards;
    -webkit-animation: closemotion 0.6s ease-in-out forwards;
    animation-delay: 0;
    -webkit-animation-delay: 0;
    }
#mySidenavclosemotion a{
    display: none;
    opacity: 0;
}
#closemarkclosemotion{
    opacity:0;
    display: none;
}
#community{ 
    width: 80%;
    height: 50px;
    margin: 10% auto 10% 20%;
    opacity:0;
    animation: sidemotion_item 0.6s ease-in-out forwards;
    -webkit-animation: sidemotion_item 0.6s ease-in-out forwards;
    animation-delay: 1s;
    -webkit-animation-delay: 1s;
}
#community a{ 
    width: 30px;
    height: 30px;
    float: left;
    margin: -8% 10% 10% 0%;;
}
.icon{ height: 28px; width:28px; display: inline-block;}
#icon_fb{   margin: 5% auto 10% 0%;   }
#icon_mail{  margin: 5% auto 10% 0%;   }
</style>
